// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/action/input-screen/app/css/app.css
// module id = 618
// module chunks = 0